import { render, staticRenderFns } from "./ModulFees.vue?vue&type=template&id=0aa41e3c&"
import script from "./ModulFees.vue?vue&type=script&lang=js&"
export * from "./ModulFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports